export default __webpack_public_path__ + "static/media/ErrorImageTimeout.485d5b31.png";